import { graphql } from 'relay-runtime'
import { allSearchChoices, Condition } from '@lifedot/constants/searchChoices'
import {
  prefecturesByRegion,
  noSuffixPrefectures as prefectures
} from '@lifedot/constants/prefectures'
import { useQuery } from 'relay-hooks/lib/useQuery'
import { dependencies_usePrefectureLinksQuery } from './__generated__/dependencies_usePrefectureLinksQuery.graphql'
import { useEffect, useState } from 'react'

export const usePrefectureLinks = (
  choiceCode?: string
): [Record<string, boolean> | undefined, Condition | undefined] => {
  const [mounted, setMounted] = useState(false)
  useEffect(() => {
    setMounted(true)
  }, [])
  const choice = allSearchChoices.find(({ code }) => code === choiceCode)
  const { data } = useQuery<dependencies_usePrefectureLinksQuery>(
    query,
    {
      choice: choice?.code ?? ''
    },
    { skip: !choice || !mounted }
  )

  if (!data?.countCemeteries) return [undefined, choice]

  return [
    {
      ...Object.keys(prefectures).reduce(
        (res, key) => ({ ...res, [key]: true }),
        {}
      ),
      ...data.countCemeteries.countsByPrefecture.reduce(
        (res, { count, roma }) => ({ ...res, [roma]: count < 1 }),
        {}
      )
    },
    choice
  ]
}
const query = graphql`
  query dependencies_usePrefectureLinksQuery($choice: String!) {
    countCemeteries(filter: { choices: [$choice] }) {
      countsByPrefecture {
        count
        roma
      }
    }
  }
`

export const areas: {
  label: string
  prefectures: { roma: string; name: string }[]
}[] = [
  {
    label: '北海道・東北',
    prefectures: [
      ...prefecturesByRegion.hokkaido,
      ...prefecturesByRegion.tohoku
    ].map((prefecture) => ({
      roma: prefecture,
      name: prefectures[prefecture]
    }))
  },
  {
    label: '関東',
    prefectures: prefecturesByRegion.kanto.map((prefecture) => ({
      roma: prefecture,
      name: prefectures[prefecture]
    }))
  },
  {
    label: '東海',
    prefectures: prefecturesByRegion.tokai.map((prefecture) => ({
      roma: prefecture,
      name: prefectures[prefecture]
    }))
  },
  {
    label: '北陸・甲信越',
    prefectures: [
      ...prefecturesByRegion.hokuriku,
      ...prefecturesByRegion.koushinetsu
    ].map((prefecture) => ({
      roma: prefecture,
      name: prefectures[prefecture]
    }))
  },
  {
    label: '関西',
    prefectures: prefecturesByRegion.kansai.map((prefecture) => ({
      roma: prefecture,
      name: prefectures[prefecture]
    }))
  },
  {
    label: '中国・四国',
    prefectures: [
      ...prefecturesByRegion.chugoku,
      ...prefecturesByRegion.shikoku
    ].map((prefecture) => ({
      roma: prefecture,
      name: prefectures[prefecture]
    }))
  },
  {
    label: '九州・沖縄',
    prefectures: prefecturesByRegion.kyushu.map((prefecture) => ({
      roma: prefecture,
      name: prefectures[prefecture]
    }))
  }
]
